"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TablePagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _ChevronLeftIcon = _interopRequireDefault(require("../../assets/Icons/ChevronLeftIcon"));

var _ChevronRightIcon = _interopRequireDefault(require("../../assets/Icons/ChevronRightIcon"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _makeStyles.default)({
  root: {
    height: 55,
    fontFamily: 'Lato',
    padding: '12px 16px',
    boxSizing: 'border-box',
    borderTop: "1px solid ".concat(_Colors.default.lightestGrey),
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    bottom: 0,
    backgroundColor: _Colors.default.white
  },
  actions: {
    display: 'flex',
    '& button': {
      marginLeft: 8
    }
  },
  pageCount: {
    marginRight: 8,
    fontSize: 15
  }
});

var TablePagination = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var count = props.count,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      className = props.className,
      backIconButtonProps = props.backIconButtonProps,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage;

  var _useStyles = useStyles(),
      actions = _useStyles.actions,
      root = _useStyles.root,
      pageCount = _useStyles.pageCount;

  var totalPages = count ? Math.ceil(count / rowsPerPage) : -1;

  var onBack = function onBack(event) {
    return onChangePage(page - 1, event);
  };

  var onNext = function onNext(event) {
    return onChangePage(page + 1, event);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "".concat(root, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: pageCount
  }, /*#__PURE__*/_react.default.createElement("div", null, count ? "".concat(page, " of ").concat(totalPages) : "Page ".concat(page))), /*#__PURE__*/_react.default.createElement("div", {
    className: actions
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
    icon: function icon(fill) {
      return /*#__PURE__*/_react.default.createElement(_ChevronLeftIcon.default, {
        fill: fill
      });
    },
    intent: "secondary",
    disabled: page === 1,
    onClick: onBack
  }, backIconButtonProps)), /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
    icon: function icon(fill) {
      return /*#__PURE__*/_react.default.createElement(_ChevronRightIcon.default, {
        fill: fill
      });
    },
    intent: "secondary",
    disabled: count ? page > totalPages - 1 : false,
    onClick: onNext
  }, nextIconButtonProps))));
});

exports.TablePagination = TablePagination;